<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        outlined
        class="rounded-lg h-100"
        @click="goToArtifact(artifact.id)"
        :elevation="hover ? 1 : 0"
      >
        <v-card-text>
          <div class="d-flex flex-column">
            <span class="text-subtitle-2 font-weight-medium text-truncate-container">
              {{ artifact.title }}
            </span>
          </div>

          <div class="text-caption text--secondary mt-1">
            {{ getTime(artifact.updatedAt) }}
          </div>
        </v-card-text>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import * as moment from 'moment/moment';

export default {
  name: 'ArtifactCard',
  props: {
    artifact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deleteArtifactId: null,
    }
  },
  computed: {},
  methods: {
    getTime(date) {
      return moment(date).fromNow();
    },
    goToArtifact(id) {
      this.$router.push({ path: `/artifacts`, query: { artifact: id } });
    },
  },
};
</script>

<style scoped>
.text-truncate-container {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.deleteSessionBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  elevation: higher;
}
</style>
